require('./src/blocks.loaders.module.js');
require('./src/components/loaders.constant.js');
require('./src/css/blocks.loading.scss');
require('./src/directives/ac.loader.directive.js');
require('./src/templates/blocks.loaders.template.js');